import * as actionTypes from "./ActionTypes"
import { APIGet, APIPost } from "services/APIRequest"
import UrlServer from "configs/UrlServer"

export const listsUserFromImportUpdate = () => {
  return dispatch => {
    APIPost(UrlServer.URL_POST_USER_FROM_IMPORT_GET,{IsCRM:true}, datas => {
      dispatch({ type: actionTypes.LISTS_USER_FROM_IMPORT_UPDATE, listsUserFromImport: datas.datas })
    })
  }
}